import Vue from 'vue';
import Vuetify, { VAutocomplete, VCombobox, VFileInput, VForm, VInput, VSelect, VTextField, VTextarea } from 'vuetify/lib';
import { Intersect } from 'vuetify/lib/directives';
Vue.use(Vuetify, {
  components: {
    VAutocomplete: VAutocomplete,
    VCombobox: VCombobox,
    VFileInput: VFileInput,
    VForm: VForm,
    VInput: VInput,
    VSelect: VSelect,
    VTextField: VTextField,
    VTextarea: VTextarea
  },
  directives: {
    Intersect: Intersect
  }
});
document.body.setAttribute('data-app', true);
var opts = {
  rtl: document.documentElement.dir === 'rtl'
};
export default new Vuetify(opts);